import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-logo-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo-banner.component.html',
  styleUrl:    './logo-banner.component.scss',
})
export class LogoBannerComponent {
  @Input() loading   = false;
  @Input() imageUrl  = '';
  @Input() title     = '';
  @Input() subtitle  = '';
  @Input() badge     = '';
  @Input() badgeColor = '#6366f1';
  @Input() compliancePercent: number | null = null;
  @Input() statusLabel = '';
  @Input() statusColor = '#22c55e';
  @Input() trend: number[] = [];

  imgError = false;

  onImgError(): void {
    this.imgError = true;
  }
}
